<form name="selectBasket" novalidate>
    <sq-modal [title]="'msg#selectBasket.title'" [buttons]="buttons">
        <div class="mb-3">
            <ul class="list-group sq-list-group">
                <li *ngFor="let basket of baskets" class="list-group-item list-group-item-action" (click)="select(basket)">{{basket.name | sqMessage}}</li>
                <li *ngIf="model.allowNew" class="list-group-item list-group-item-action" (click)="newBasket()"><i>{{'msg#selectBasket.newBasket' | sqMessage}}</i></li>
            </ul>
        </div>
    </sq-modal>
</form>